import { render, staticRenderFns } from "./CommonImgModal.vue?vue&type=template&id=07c6d992&scoped=true&"
import script from "./CommonImgModal.vue?vue&type=script&lang=js&"
export * from "./CommonImgModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonImgModal.vue?vue&type=style&index=0&id=07c6d992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6d992",
  null
  
)

export default component.exports